import React, { useCallback, useEffect, useRef } from 'react';
import { useParams } from 'react-router';
import { AdminTaskList, useTaskManager } from '@css-xp/apd-task-manager';
import './admin-task-manager.scss';
import { useFeatureToggle, useTitle } from '@css-xp/base';
import { ENABLE_RECENTLY_VISITED_HISTORY } from '@atlassian/cssxp-utils-generic';

interface AdminTaskManagerProps {
  title?: string;
}

const AdminTaskManager = ({ title }: AdminTaskManagerProps) => {
  const { taskId } = useParams<{ taskId: string }>();
  const [isEnabled] = useFeatureToggle();
  if (isEnabled(ENABLE_RECENTLY_VISITED_HISTORY)) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useTitle(taskId, title);
  }
  const { openTaskSidebar, closeTaskSidebar } = useTaskManager();

  const taskManagerRef = useRef<any>();
  const refetch = useCallback(() => {
    taskManagerRef.current.reload();
  }, []);

  useEffect(() => {
    if (taskId) {
      openTaskSidebar({ taskId, refetch, refetchAll: refetch });
    } else {
      closeTaskSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskId]);

  return (
    <div className="admin-task-manager">
      <h1>Manage Requests</h1>
      <AdminTaskList ref={taskManagerRef} />
    </div>
  );
};

export default AdminTaskManager;
